export function updatePaymentModes(
    paymentModes: PaymentModesType,
    isCreatingVoucherAccepted: boolean
): PaymentModesType {
    let localPaymentModes: PaymentModesType = [];
    const changeMachinePaymentMode = paymentModes.find(
        (mode: PaymentModeType) => mode.paymentMode === "changeMachine"
    );

    const changeMachinePaymentModeIndex = paymentModes.indexOf(
        changeMachinePaymentMode as PaymentModeType
    );

    localPaymentModes = paymentModes.map((paymentMode: PaymentModeType) => {
        return { ...paymentMode };
    });

    if (changeMachinePaymentMode !== undefined) {
        if (isCreatingVoucherAccepted) {
            const voucherMode = paymentModes.find(
                (mode: PaymentModeType) => mode.paymentMode === "voucher"
            );

            if ((voucherMode as PaymentModeType).paymentAmount < 0) {
                localPaymentModes[changeMachinePaymentModeIndex] = {
                    ...localPaymentModes[changeMachinePaymentModeIndex],
                    totalAmountDeposited:
                        changeMachinePaymentMode.paymentAmount +
                        Math.abs(
                            (voucherMode as PaymentModeType).paymentAmount
                        ),
                };
            }
        } else {
            localPaymentModes[changeMachinePaymentModeIndex] = {
                ...localPaymentModes[changeMachinePaymentModeIndex],
                totalAmountDeposited:
                    changeMachinePaymentMode.paymentAmount +
                    changeMachinePaymentMode.data.renderAmount,
            };
        }
    }
    return localPaymentModes;
}
